module.exports = __webpack_public_path__ + "static/img/MV11.6f3a76d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV11.jpg
// module id = SK5L
// module chunks = 0